import React from 'react';
import { ArrowRight, Rocket, CheckCircle2, Wand2 } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function CallToAction() {
  const {
    t
  } = useLanguage();
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.2
  });
  return <section className="relative py-16 md:py-24 lg:py-32 bg-[#050505] overflow-hidden" data-id="element-29">
      {/* Static background gradient */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-30">
        <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-purple-600/5 rounded-full" data-id="element-31" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-purple-800/5 rounded-full" data-id="element-32" />
      </div>

      <div ref={ref} className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10" data-id="element-33">
        {/* Badge */}
        {t.cta.badge && <div className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-blue/10 border border-accent-blue/20 text-accent-blue text-sm font-medium mb-6 md:mb-8 animate-hidden animate-fade-in ${isVisible ? 'animate-visible' : ''}`} data-id="element-34">
            <Rocket className="w-3.5 h-3.5" data-id="element-35" />
            {t.cta.badge}
          </div>}

        {/* Headlines */}
        <h2 className={`text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 md:mb-8 tracking-tight leading-tight animate-hidden animate-fade-up delay-100 ${isVisible ? 'animate-visible' : ''}`} data-id="element-36">
          {t.cta.title}
        </h2>

        <p className={`text-lg md:text-xl lg:text-2xl text-gray-300 mb-8 md:mb-12 max-w-2xl mx-auto leading-relaxed animate-hidden animate-fade-up delay-200 ${isVisible ? 'animate-visible' : ''}`} data-id="element-37">
          {t.cta.subtitle}
        </p>

        {/* Benefits List */}
        {t.cta.benefits && t.cta.benefits.length > 0 && <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-8 md:mb-10" data-id="element-38">
            {t.cta.benefits.map((benefit: string, index: number) => <div key={index} className={`flex items-center gap-2 text-gray-400 animate-hidden animate-fade-in ${isVisible ? 'animate-visible' : ''}`} style={{
          transitionDelay: `${300 + index * 100}ms`
        }} data-id="element-39">
                <CheckCircle2 className="w-5 h-5 text-accent-blue" data-id="element-40" />
                <span data-id="element-41">{benefit}</span>
              </div>)}
          </div>}

        {/* CTA Button */}
        <div className={`flex flex-col items-center gap-6 mb-12 md:mb-20 animate-hidden animate-scale-in delay-500 ${isVisible ? 'animate-visible' : ''}`} data-id="element-42">
          <a href="#rating" className="group relative px-8 py-4 md:px-10 md:py-5 bg-accent-blue text-white rounded-2xl font-bold text-lg md:text-xl shadow-xl shadow-accent-blue/30 hover:shadow-accent-blue/50 hover:bg-accent-hover transition-all duration-300 flex items-center gap-3" data-id="element-43">
            <Wand2 className="w-5 h-5 md:w-6 md:h-6" data-id="element-44" />
            {t.cta.button}
            <ArrowRight className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform" data-id="element-45" />
          </a>
        </div>
      </div>
    </section>;
}